import React from 'react';
import { getClearButtonWrapper, parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';

export const NumberField = props => {
  const renderOptions = parseRenderOptions(props);
  // Get wrapper information if clear button can be visible
  const { Tag, props: tagProps, content } = getClearButtonWrapper(
    renderOptions,
    props,
  );
  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <Tag {...tagProps}>
        <input
          ref={props.focusRef}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'is-invalid': renderOptions.hasErrors,
            'has-btn': renderOptions.hasClear && !!props.value,
            'is-empty': !props.value,
          })}
          type="number"
          id={props.id}
          name={props.name}
          // Set empty/null value to an empty string because inputs don't like
          // null values
          value={
            typeof props.value === 'number' && !isNaN(props.value)
              ? props.value
              : ''
          }
          onBlur={props.onBlur}
          // Parse the input to an integer, or set to null if empty
          onChange={e => {
            const parsedValue = parseInt(e.target.value);
            props.onChange(
              typeof parsedValue === 'number' && !isNaN(parsedValue)
                ? parsedValue
                : null,
            );
          }}
          onFocus={props.onFocus}
          placeholder={renderOptions.placeholder}
          disabled={!props.enabled}
          form={props.form}
          min={renderOptions.custom.min}
          max={renderOptions.custom.max}
          step={renderOptions.custom.step}
        />
        {content}
      </Tag>
    </FieldWrapper>
  );
};
